'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var NewCalendarController = function NewCalendarController($scope, CommonUiConstants, constants, newCalendarService, specialEventsService, specialEventsGridService, dataRetrieverService, retrieverConstants, featureToggleService, $log, gridDropdownPopulateService, specialEventsCsvService) {
  $scope.seasonalityNameRegex = CommonUiConstants.SEASONALITY_NAME_REGEX;
  $scope.DATE_SETTINGS = {
    showTodayButton: false
  };
  $scope.demandMode = constants.CALENDAR_MODES.DEMAND;
  $scope.specialEventsGridId = constants.SPECIAL_EVENTS_NEW_CALENDAR_GRID_ID;
  $scope.submitted = false;
  $scope.reviewInputChart = {
    visible: false
  };
  $scope.numberOfSeasons = _.times(5, function (index) {
    return {
      id: index + 1
    };
  });

  //numbers must be odd
  $scope.smoothingNumberOfWeeks = [{
    id: 1
  }, {
    id: 3
  }, {
    id: 5
  }];
  $scope.POSITIVE_FLOAT_PERSISTENCE_2_PATTERN = CommonUiConstants.POSITIVE_FLOAT_PERSISTENCE_2_PATTERN;
  $scope.POSITIVE_FLOAT_PERSISTENCE_1_PATTERN = CommonUiConstants.POSITIVE_FLOAT_PERSISTENCE_1_PATTERN;
  $scope.outlierWarning = 'Maximum allowed value is 5.0';
  $scope.minDeviationWarning = 'Maximum decimal places allowed is 2';
  $scope.outlierPatternWarning = 'Maximum decimal places allowed is 1';
  $scope.isDuplicateCalendar = false;
  $scope.isPooledDemandCalendar = false;
  $scope.initUiDates = function () {
    $scope.maxDateTo = $scope.calendar.dateRangeTo;
    $scope.maxDateFrom = $scope.calendar.dateRangeFrom;
    $scope.uiDateRangeTo = $scope.calendar.dateRangeTo;
    $scope.uiDateRangeFrom = $scope.calendar.dateRangeFrom;
  };
  $scope.initCopyCalendarModel = function () {
    $scope.calendar.name = $scope.calendar.name + ' Copy';
  };
  $scope.initNewCalendarModel = function () {
    $scope.calendar.markets = _.map($scope.marketList, 'value');
  };
  $scope.initModel = function () {
    $scope.initUiDates();
    if (_.isEmpty($scope.calendar.name)) {
      $scope.initNewCalendarModel();
    } else {
      $scope.initCopyCalendarModel();
    }
  };
  $scope.initSelectedMarkets = function () {
    $scope.calendar.selectedMarkets = _.map($scope.calendar.markets, function (market) {
      return {
        market: market,
        selected: true
      };
    });
  };
  $scope.initMarketsForSpecialEvents = function () {
    var specialEventMarkets = validateCalendarList($scope.calendar) ? $scope.calendar.markets : [];
    gridDropdownPopulateService.setSpecialEventMarkets(specialEventMarkets);
  };
  $scope.initModel();
  function showEventsError(msg) {
    $log.error('NewCalendarController: showSubmitCalendarModal - ' + msg);
    toastr.error(msg);
    return false;
  }
  $scope.validateSpecialEvents = function () {
    $scope.calendar.eventsForSubmit = specialEventsService.createSpecialEventsRequest($scope.calendar.events);
    var specialEventsCheck = newCalendarService.validateSpecialEvents($scope.calendar.eventsForSubmit);
    if (specialEventsCheck !== '_clear') {
      return showEventsError(specialEventsCheck);
    }
    specialEventsCheck = newCalendarService.validateSpecialEventsDates($scope.calendar.eventsForSubmit);
    if (specialEventsCheck !== '_clear') {
      return showEventsError(specialEventsCheck);
    }
    return true;
  };
  $scope.showSubmitCalendarModal = function () {
    if ($scope.validateSpecialEvents() && validateCalendar($scope.calendar)) {
      $scope.initSelectedMarkets();
      $scope.openSubmitModal();
    }
  };
  $scope.validateUniqNameAndSubmit = function () {
    $scope.isDuplicateCalendar = false;
    dataRetrieverService.getDataRetriever(retrieverConstants.SEASONALITY_SCREEN, retrieverConstants.SEASONALITY_DEMAND_MODE).localSortApplied().retrieveComponentData('seasonality-demand-calendars').then(function (data) {
      var filteredExistingCalendar = _.filter(data, function (calendar) {
        return calendar.calendarName === $scope.calendar.name;
      });
      if (filteredExistingCalendar.length > 0) {
        $scope.isDuplicateCalendar = true;
      } else {
        $scope.submitNewCalendar();
      }
    });
  };
  $scope.submitNewCalendar = function () {
    $scope.sendNewCalendarRequest();
  };
  $scope.$watch('uiDateRangeTo', function (newValue, oldValue) {
    if (!newValue) {
      return;
    }
    if (!newValue.isSame(oldValue)) {
      $scope.calendar.dateRangeTo = newValue;
    }
    $scope.calendar.dateRangeFrom = newValue.subtract(363, 'days');
    if (!$scope.uiDateRangeFrom || !$scope.uiDateRangeFrom.isSame($scope.calendar.dateRangeFrom)) {
      $scope.uiDateRangeFrom = $scope.calendar.dateRangeFrom;
    }
  });
  $scope.$watch('uiDateRangeFrom', function (newValue, oldValue) {
    if (!newValue) {
      return;
    }
    if (!newValue.isSame(oldValue)) {
      $scope.calendar.dateRangeFrom = newValue;
    }
    $scope.calendar.dateRangeTo = newValue.add(363, 'days');
    if (!$scope.uiDateRangeTo || !$scope.uiDateRangeTo.isSame($scope.calendar.dateRangeTo)) {
      $scope.uiDateRangeTo = $scope.calendar.dateRangeTo;
    }
  });
  $scope.$on('seasonality-review-input-data:mark-user-exclusion', function (event, newEventsList) {
    var userExclusionData = specialEventsService.buildUserExclusionEventsData(newEventsList, $scope.calendar.events);
    specialEventsGridService.processUserExclusionData($scope.calendar.events, userExclusionData);
    $scope.$broadcast('grid:loadData:' + constants.SPECIAL_EVENTS_NEW_CALENDAR_GRID_ID);
    updateReviewInputDataChart(userExclusionData);
  });
  $scope.importFromCsv = function (fileData) {
    return specialEventsCsvService.importFromCsv(fileData, $scope.calendar.markets).then(function (result) {
      $scope.calendar.events = result.rows;
      var exclusionData = getExclusionFromEvents($scope.calendar.events, 'add');
      $scope.$broadcast('grid:loadData:' + constants.SPECIAL_EVENTS_NEW_CALENDAR_GRID_ID);
      _.forEach(exclusionData, function (marketUserExclusionData) {
        updateReviewInputDataChart(marketUserExclusionData);
      });
      return result;
    });
  };
  function getExclusionFromEvents(events, mode) {
    return _.chain(events).filter(specialEventsGridService.isUserExclusionEvent).groupBy('market').transform(function (data, values, key) {
      var exclusionData = {
        market: key,
        add: [],
        remove: []
      };
      exclusionData[mode] = _.map(values, function (exclusionEvent) {
        return _.pick(exclusionEvent, ['startDate', 'endDate']);
      });
      data.push(exclusionData);
      return data;
    }, []).value();
  }
  $scope.removeEventsCallback = function (removedEvents) {
    var result = getExclusionFromEvents(removedEvents, 'remove');
    _.forEach(result, function (marketUserExclusionData) {
      updateReviewInputDataChart(marketUserExclusionData);
    });
  };
  function updateReviewInputDataChart(userExclusionData) {
    $scope.$broadcast('seasonality-review-input-data:process-user-exclusion-event', userExclusionData);
  }
  function onRequestSuccess() {
    $scope.submitted = true;
    toastr.success('Your calendar has been successfully submitted.');
  }
  function onRequestFail() {
    $scope.submitted = true;
    $log.error('NewCalendarController: onRequestFail - An error has occurred. Please try again');
    toastr.error('An error has occurred. Please try again.');
  }
  $scope.sendNewCalendarRequest = function () {
    newCalendarService.sendNewCalendarRequest($scope.calendar, $scope.isPooledDemandCalendar).then(onRequestSuccess, onRequestFail)["finally"](function () {
      $scope.closeSubmitModal();
    });
  };
  function validateDowGroups(calendar) {
    var days = _.chain(calendar.dowGroups).map('days').compact().flatMap().value();
    return days.length === 7;
  }
  function validateSeasonNumber(calendar) {
    return calendar.maxNumberOfSeasons.id >= calendar.minNumberOfSeasons.id;
  }
  function validateSeasonDeviance(calendar) {
    return calendar.minDevBetweenSeasons && calendar.minDevBetweenSeasons >= 0;
  }
  function validateOutlier(calendar) {
    return calendar.outlierTolerance && calendar.outlierTolerance >= 0;
  }
  function validateCalendarList(calendar) {
    return !_.isEmpty(calendar.markets);
  }
  function validateSmoothingNumberOfWeeks(calendar) {
    return calendar.smoothingNumberOfWeeks.id && (calendar.smoothingNumberOfWeeks.id === 1 || calendar.smoothingNumberOfWeeks.id === 3 || calendar.smoothingNumberOfWeeks.id === 5);
  }
  function validateCalendar(calendar) {
    return validateSeasonNumber(calendar) && validateSeasonDeviance(calendar) && validateOutlier(calendar) && validateDowGroups(calendar) && validateCalendarList(calendar) && validateSmoothingNumberOfWeeks(calendar);
  }
  $scope.setValidationFlag = function () {
    if (_.isEmpty($scope.calendar) || _.isNil($scope.calendar.markets)) {
      return;
    }
    $scope.isCalendarValid = validateCalendar($scope.calendar);
  };
  $scope.$watchGroup(['calendar.minNumberOfSeasons', 'calendar.maxNumberOfSeasons', 'calendar.outlierTolerance', 'calendar.minDevBetweenSeasons', 'calendar.smoothingNumberOfWeeks'], function (newValues, oldValues) {
    if (!_.isEqual(newValues, oldValues)) {
      $scope.setValidationFlag();
    }
  });
  $scope.$watch('calendar.markets', function (newValue, oldValue) {
    if (_.isEqual(newValue, oldValue)) {
      return;
    }
    if (_.isEmpty($scope.calendar)) {
      gridDropdownPopulateService.setSpecialEventMarkets([]);
      return;
    }
    gridDropdownPopulateService.setSpecialEventMarkets($scope.calendar.markets);
    $scope.setValidationFlag();
  });
};
NewCalendarController.$inject = ['$scope', 'CommonUiConstants', 'SeasonalityConstants', 'NewCalendarService', 'SpecialEventsService', 'SpecialEventsGridService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'FeatureToggleService', '$log', 'GridDropdownPopulateService', 'SpecialEventsCsvService'];
module.exports = NewCalendarController;